import React from "react";
import { FaDownload } from "react-icons/fa";
import { MdKeyboard } from "react-icons/md";
import header from "../../assets/security-img.png";
import "./Security.css";

const Security = () => {
  return (
    <div className="security-container">
      <div className="security-images">
        <img src={header} alt="security" />
      </div>

      <div className="security-content">
        <h1 className="security-title">Security as it should be</h1>
        <p className="security-description">
          TokenPocket generates and stores keys and passwords on your device
          only, only you can access your account and assets.
        </p>
        <p className="security-description">
          TokenPocket also develops hardware cold wallet and MultiSig wallet
          feature to enhance the security as you need.
        </p>
        <p className="security-description">
          Supporting BTC, ETH, BSC, TRON, Aptos, Polygon, Solana, Cosmos,
          Polkadot, EOS, IOST and so on.
        </p>
        <div className="security-buttons">
          <button className="download-button">
            <FaDownload /> Download
          </button>
          <button className="keypal-button">
            <MdKeyboard /> KeyPal
          </button>
        </div>
      </div>
    </div>
  );
};

export default Security;
